import { render, staticRenderFns } from "./dashboardIframePublico.vue?vue&type=template&id=19fddbd5&"
import script from "./dashboardIframePublico.vue?vue&type=script&lang=js&"
export * from "./dashboardIframePublico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports